{
  "zoomControl": {
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "resetZoom": "Reset Zoom"
  },
  "roleTesting": {
    "title": "Role Testing",
    "testingAsLabel": "Testing as",
    "exitButton": "Exit Role Testing",
    "close": "Close",
    "tooltipFormat": "Testing as {{role}} - Click to change"
  },
  "languageSwitcher": {
    "title": "Language",
    "selectLabel": "Language",
    "close": "Close",
    "tooltip": "{{language}} - Click to change",
    "exitButton": "Exit"
  },
  "support": {
    "contactSupport": "Contact Support",
    "dialogTitle": "Support Inquiry",
    "tutorialVideos": "Tutorial Videos",
    "questionLabel": "Question",
    "questionPlaceholder": "Your support inquiry goes here...",
    "cancelButton": "Cancel",
    "sendButton": "Send",
    "successMessage": "Thank you! Your support request has been received. We will reach out to you shortly."
  },
  "selectTailNumber": {
    "tailNumberLabel": "Tail #",
    "notInRegistryShort": "Not in registry yet.",
    "notInRegistryLong": "This aircraft isn't in our registry yet.",
    "requestButton": "Request",
    "requestDialogTitle": "Submit Aircraft Request",
    "requestDialogDescription": "Review the details below and click 'Submit Request' to add this aircraft to our registry.",
    "tailNumberFieldLabel": "Tail Number",
    "fboLabel": "FBO",
    "requestedByLabel": "Requested By",
    "cancelButton": "Cancel",
    "submitRequestButton": "Submit Request",
    "submitting": "Submitting...",
    "requestErrorMessage": "Unable to submit request. Please try again.",
    "waitForCredentials": "Please wait while we verify your credentials",
    "confirmationTitle": "✈️ Aircraft Request Sent!",
    "confirmationMessage": "We've received your request for aircraft <strong>{{tailNumber}}</strong>. Our team will review and add it to the registry soon. You'll be notified once it's available.",
    "gotItButton": "Got it!"
  },
  "splitButton": {
    "ariaLabel": "split button",
    "selectStrategyAriaLabel": "select merge strategy"
  },
  "speedDialNav": {
    "label": "Label",
    "simplifyDemo": "Simplify Demo",
    "demo": "Demo",
    "userManagement": "User Management"
  },
  "windDisplay": {
    "loading": "Loading...",
    "noData": "--"
  },
  "dateRangeControl": {
    "startDate": "Start Date",
    "endDate": "End Date",
    "next7Days": "Next 7 Days",
    "thisWeek": "This Week",
    "next30Days": "Next 30 Days",
    "next60Days": "Next 60 Days"
  },
  "favorites": {
    "nameLabel": "Name",
    "saveButton": "Save",
    "overwriteConfirm": "A favorite named '{{name}}' already exists. Do you want to overwrite it?",
    "overwriteButton": "Yes, overwrite it"
  },
  "assignTripButton": {
    "assigned": "Assigned",
    "assign": "Assign",
    "assignTo": "Assign to {{locationName}}",
    "assignedTo": "Assigned to {{locationName}}",
    "assignSelected": "Assign {{count}} selected trips",
    "assignCount": "Assign ({{count}})",
    "thisHangar": "This Hangar",
    "thisRamp": "This Ramp",
    "successMessage": "Assigned {{tailNumber}} to {{locationName}}",
    "bulkSuccessMessage": "Assigned {{count}} trips to {{locationName}}",
    "errorMessage": "Failed to assign trip"
  },
  "layoutToolbar": {
    "tooltips": {
      "measuringTool": "Measuring Tool"
    },
    "buttons": {
      "clear": "Clear",
      "dump": "Dump",
      "print": "Print",
      "copy": "Copy",
      "share": "Share",
      "allTenants": "All Tenants"
    },
    "confirmations": {
      "pleaseConfirm": "Please Confirm",
      "clearMultiHangar": "This will remove all aircraft listed in the selected hangars.",
      "clearNuclear": "☢️ NUCLEAR OPTION: This will unassign ALL aircraft from this {{locationType}} from the current time through the end of their trips. This cannot be undone easily. Are you sure?",
      "clearLocation": "This will remove all aircraft listed in this {{locationType}}.",
      "clearNuclearOk": "Yes, clear all trips (NUCLEAR)",
      "clearLocationOk": "Yes, remove all aircraft",
      "dumpMultiHangar": "This will dump all aircraft from the selected hangars.",
      "dumpScheduled": "This will remove all aircraft from this {{locationType}} for their entire trip duration.",
      "dumpLocation": "This will dump all aircraft to the front.",
      "dumpHangarsOk": "Yes, dump hangars",
      "dumpScheduledOk": "Yes, remove from {{locationType}}",
      "dumpLocationOk": "Yes, dump hangar",
      "resetMultiHangar": "This will reset the selected hangars to the all tenant hangar layout.",
      "resetLocation": "This will reset to the all tenant {{locationType}} layout.",
      "resetOk": "Yes, reset",
      "printHangarsTitle": "Print Hangars",
      "printHangarsCaption": "Select the hangars you would like to print.",
      "copyHangarsTitle": "Copy Hangars",
      "copyHangarsCaption": "Select the hangars you would like to copy."
    },
    "messages": {
      "copiedToClipboard": "Copied to clipboard",
      "urlCopiedToClipboard": "URL copied to clipboard"
    },
    "errors": {
      "failedToCopyUrl": "Failed to copy URL",
      "failedToCopyImage": "Failed to copy the image to clipboard. The image may be too large or there might be an issue with background images.",
      "copyFailedDetailed": "Copy failed for {{locationType}} \"{{locationName}}\". Canvas size: {{canvasWidth}}x{{canvasHeight}}. Check browser console for detailed logs.",
      "copyFailedGeneric": "Failed to copy {{locationType}} to clipboard. The image may be too large for your device's memory or there was an issue with aircraft rendering. Try again or check the console for details.",
      "multiHangarCopyFailedDetailed": "Multi-hangar copy failed. Canvas size: {{canvasWidth}}x{{canvasHeight}}. Selected hangars: {{hangarCount}}. Check browser console for detailed logs.",
      "multiHangarCopyFailedGeneric": "Failed to copy multi-hangar layout to clipboard. The image may be too large for your device's memory or there was an issue with aircraft rendering. Selected {{hangarCount}} hangars. Try selecting fewer hangars or check the console for details."
    },
    "dialogs": {
      "featureNotSupported": {
        "title": "Feature Not Supported",
        "message": "This feature is not supported on Firefox. If you wish to use this feature, please use a different browser.",
        "okButton": "OK"
      },
      "copyFailed": {
        "title": "Copy Failed",
        "okButton": "OK"
      }
    }
  },
  "favoritesButton": {
    "buttons": {
      "favorites": "Favorites"
    },
    "dialogs": {
      "saveFavoriteTitle": "Save Favorite Stack",
      "favoritesTitle": "Favorites",
      "pleaseConfirm": "Please Confirm"
    },
    "emptyState": {
      "imageAlt": "No favorites",
      "message": "No favorites currently saved. Click the \"Save\" icon to start saving your favorites stacks."
    },
    "multiHangarFavorites": {
      "buttons": {
        "use": "Use",
        "delete": "Delete"
      },
      "confirmations": {
        "useText": "Remove all aircraft from selected hangar(s) and replace with aircraft for '{{stackName}}'.",
        "useNote": "Note: Aircraft in this saved stack will be moved from other hangars if needed.",
        "useOk": "Yes, reset",
        "deleteText": "You are about to delete '{{stackName}}' from all selected hangars.",
        "deleteNote": "Meaning…that if '{{stackName}}' is saved for hangars A, B, C…but I've only selected A and B…then C still keeps its saved '{{stackName}}'",
        "deleteOk": "Yes, delete this favorite"
      },
      "stackColumn": "Stack",
      "searchPlaceholder": "Search for stack",
      "noStack": "No stack"
    },
    "singleFavorite": {
      "printSubtitle": "Favorite: {{name}}",
      "searchPlaceholder": "Search for stack",
      "buttons": {
        "use": "Use",
        "delete": "Delete",
        "print": "Print"
      },
      "confirmations": {
        "title": "Please Confirm",
        "useText": "Remove all aircaft from your current {{locationType}} and replace with aircraft from '{{name}}'.",
        "useOk": "Yes, reset to this saved stack",
        "deleteText": "You are about to delete {{name}}.",
        "deleteOk": "Yes, delete this favorite"
      }
    }
  },
  "multiLocationSave": {
    "labels": {
      "name": "Name"
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "confirmations": {
      "overwriteMessage": "A favorite named '{{name}}' already exists. Do you want to overwrite it?",
      "overwriteOk": "Yes, overwrite it"
    }
  },
  "addMovableObstacle": {
    "buttonText": "Add Movable Obstacle",
    "dialogTitle": "Add Movable Obstacle",
    "cancelButton": "Cancel",
    "doneButton": "Done",
    "movableObstacleGrid": {
      "columns": {
        "name": "Name",
        "lengthFt": "Length (ft)",
        "widthFt": "Width (ft)",
        "heightFt": "Height (ft)"
      },
      "notAvailable": "N/A",
      "addButton": "Add",
      "searchPlaceholder": "Search for an obstacle type by name",
      "messages": {
        "addSuccess": "{{obstacleName}} added to {{locationName}}",
        "addError": "Failed to add {{obstacleName}}: {{errorMessage}}"
      }
    }
  },
  "addFBO": {
    "buttonLabel": "Add FBO",
    "dialogTitle": "Add a New FBO",
    "instructions": "Create a new FBO and invite the first user.",
    "successMessage": "An email has been sent to <b style=\"color: #3c6ce9\">{{email}}</b> with an invite to <b style=\"color: #3c6ce9\">{{name}}</b>. You can also use the link below.",
    "nameLabel": "Name",
    "emailLabel": "Email Address",
    "okButton": "OK",
    "cancelButton": "Cancel",
    "addButton": "Add"
  },
  "buttonMoveTo": {
    "assignTo": "Assign To",
    "moveTo": "Move To",
    "unassigned": "Unassigned"
  },
  "buttonNotes": {
    "buttonText": "Notes"
  },
  "editTenant": {
    "dialogTitle": "Edit Aircraft",
    "selectAircraftLabel": "Select an Aircraft",
    "duplicateTailWarning": "Duplicate tail number",
    "ownerManagerLabel": "Owner/Manager",
    "notesLabel": "Notes",
    "notesPlaceholder": "Add notes about this aircraft...",
    "lastUpdate": "Last update: {{time}} ({{date}}) by {{user}}",
    "typeLabel": "Type",
    "tenantOption": "Tenant",
    "transientOption": "Transient",
    "yellowCardLabel": "Yellow Card (YC)",
    "unassignedText": "Unassigned",
    "naText": "N/A",
    "notHangaredText": "Not Hangared",
    "confirmTitle": "Please Confirm",
    "transientConfirmText": "Making this Base Tenant into a Transient means this aircraft is no longer based in your hangars. It will remain on your transient list of aircraft.",
    "transient": "Transient",
    "base": "Base",
    "cancelButton": "Cancel",
    "saveButton": "Save",
    "insufficientPermissionTitle": "Insufficient Permission",
    "insufficientPermissionText": "Insufficient permission to modify a base tenant. Currently you have the role of <u>{{roleName}}</u>. You need to be an <u>FBO Admin</u> or <u>Manager</u> to modify a base tenant. Please contact your AirPlx admin if you think this is a mistake."
  },
  "aircraftSpecsTooltip": {
    "heightLabel": "H: {{height}}"
  },
  "fboMenu": {
    "switchFBO": "Switch FBO",
    "noFBOTitle": "No FBO Found",
    "noFBOMessage": "You currently do not belong to an FBO. Please contact your system administrator to join one.",
    "okButton": "OK"
  },
  "buttonUploadImage": {
    "compressingMessage": "Compressing image. This will take a few seconds."
  },
  "selectDumpTo": {
    "label": "To:",
    "holdingArea": "Holding Area",
    "frontOfHangar": "Front of Hangar"
  },
  "locationTextField": {
    "unassigned": "Unassigned",
    "ramp": "Ramp",
    "hangar": "Hangar",
    "assignedLabel": "Assigned {{locationType}}",
    "currentLabel": "Current {{locationType}}"
  },
  "aircraftListItem": {
    "tenant": "Tenant",
    "transient": "Transient",
    "yc": "YC",
    "noseIn": "Nose In",
    "tailIn": "Tail In",
    "front": "Front",
    "back": "Back",
    "okOutside": "OK Outside",
    "locked": "Locked"
  },
  "timelineAircraftList": {
    "title": "Timeline",
    "aircraftCount": "{{count}} aircraft",
    "filterPlaceholder": "Filter...",
    "searchPlaceholder": "Search tail number across all trips...",
    "countOfTotal": "{{filtered}} of {{total}}",
    "totalAndHere": "{{total}} total • {{here}} here",
    "filteredAndHere": "{{filtered}} of {{total}} • {{filteredHere}} here",
    "noAircraftFound": "No aircraft found with tail number \"{{tailNumber}}\"",
    "createNewTrip": "Create New Trip"
  },
  "multiHangarSelect": {
    "selectAll": "Select All",
    "cancel": "Cancel",
    "ok": "OK"
  },
  "timelineAircraftListItem": {
    "cancelled": "CANCELLED",
    "here": "HERE",
    "hereNow": "HERE NOW",
    "unassigned": "Unassigned",
    "unassignedStatus": "UNASSIGNED",
    "atLocation": "AT {{locationName}}",
    "arrivesInHours": "ARRIVES IN {{hours}}H",
    "arrivesInDays": "ARRIVES IN {{days}}D",
    "unknownAircraft": "Unknown Aircraft"
  },
  "aircraftPreferencesMenu": {
    "tailIn": "Tail In",
    "noseIn": "Nose In",
    "frontRow": "Front Row",
    "backRow": "Back Row",
    "okOutside": "OK Outside",
    "locked": "Locked",
    "incrementalPark": "Incremental Park",
    "editAircraft": "Edit Aircraft",
    "removeAircraft": "Remove Aircraft",
    "removeObstacle": "Remove Obstacle",
    "confirmRemove": "Yes, remove this aircraft",
    "confirmTitle": "Please Confirm",
    "confirmTextReference": "Making this Tenant into a Transient means this aircraft is no longer based in your hangars. It will remain on your transient list of aircraft.",
    "confirmTextRemove": "This aircraft will be removed from this {{locationType}}.",
    "hangar": "hangar",
    "ramp": "ramp"
  },
  "aircraftActionMenu": {
    "noActiveTripWarning": "No active or upcoming trip found for this aircraft",
    "tripDetailsNotFound": "Could not find trip details",
    "assignedForEntireTrip": "{{tailNumber}} assigned to {{locationName}} for entire trip",
    "failedAssignEntireTrip": "Failed to assign entire trip",
    "assigned": "{{tailNumber}} assigned to {{locationName}}",
    "failedAssignAircraft": "Failed to assign aircraft",
    "jumpTo": "Jump to...",
    "assignHere": "Assign Here",
    "assignHereEntireTrip": "Assign Here (Entire Trip)",
    "failedLoadTrips": "Failed to load trips for this aircraft",
    "viewTrips": "View Trips",
    "hereAt": "— Here at {{locationName}} —",
    "hoursStay": "{{hours}}h stay",
    "otherLocations": "— Other Locations —",
    "andMoreAt": "...and {{count}} more at {{locationName}}",
    "todayAt": "Today at {{time}}",
    "tomorrowAt": "Tomorrow at {{time}}",
    "yesterdayAt": "Yesterday at {{time}}",
    "inDaysAt": "In {{days}} days at {{time}}"
  },
  "bulkActionToolbar": {
    "tripsSelected": "{{count}} trip selected",
    "selectLocation": "Select location...",
    "assign": "Assign",
    "unassign": "Unassign",
    "cancel": "Cancel",
    "delete": "Delete",
    "clear": "Clear"
  },
  "scheduledAircraftContextMenu": {
    "confirmTitle": "Please Confirm",
    "confirmRemoveText": "This will remove the aircraft from the schedule at this time.",
    "confirmRemoveButton": "Yes, remove from schedule",
    "missingDataError": "Missing required data for location change",
    "conflictError": "Another aircraft is already in this location at this time",
    "gapError": "Cannot create gaps in the schedule",
    "updateLocationError": "Failed to update location",
    "loadTripsError": "Failed to load trips for this aircraft",
    "viewTrips": "View Trips",
    "unlock": "🔓 Unlock",
    "lock": "🔒 Lock",
    "tailIn": "Tail In",
    "noseIn": "Nose In",
    "frontRow": "Front Row",
    "backRow": "Back Row",
    "okOutside": "OK Outside",
    "locked": "Locked",
    "moveTo": "Move To",
    "editAircraft": "Edit Aircraft",
    "removeAircraft": "Remove Aircraft",
    "unassigned": "Unassigned"
  },
  "addTenantButton": {
    "tooltipAddTrip": "Add Trip",
    "tooltipAddAircraft": "Add Aircraft",
    "buttonAddTrip": "Add Trip",
    "buttonAddAircraft": "Add Aircraft",
    "dialogTitleAddTrip": "Add Trip",
    "dialogTitleAddAircraft": "Add Aircraft",
    "tabs": {
      "newAircraft": "New Aircraft",
      "priorTransients": "Prior Transients",
      "tenants": "Tenants",
      "bulkAdd": "Bulk Add",
      "addTrip": "Add Trip",
      "allTrips": "All Trips",
      "bulkUpload": "Bulk Upload",
      "addMovableObstacle": "Add Movable Obstacle"
    },
    "buttons": {
      "cancel": "Cancel",
      "add": "Add",
      "createTrip": "Create Trip",
      "creating": "Creating...",
      "saveTrips": "Save Trips",
      "saving": "Saving...",
      "done": "Done"
    },
    "notifications": {
      "addedToLocation": "{{model}} added to {{locationName}}",
      "added": "{{model}} added",
      "tryAutostack": "Try running AutoStack to see your new aircraft in action!",
      "runAutostack": "Run AutoStack"
    },
    "confirmTitle": "Please Confirm",
    "confirmHangar": "We'll assign this new Base Tenant to this hangar. If you need to change default hangar assignments, you can do that by editing this specific aircraft.",
    "confirmRamp": "We'll assign this new Tie-Down Tenant to this ramp. If you need to change default ramp assignments, you can do that by editing this specific aircraft."
  },
  "viewSettings": {
    "buttonText": "View Settings",
    "locationNotAvailable": "Location not available",
    "tugUpdatedSuccess": "Tug updated for {{locationName}}",
    "tugUpdateError": "Failed to update tug",
    "tailNumberTooltip": "Display tail number on aircraft",
    "tailNumberLabel": "Tail #",
    "notesTooltip": "To see single note vs all notes, go to Settings > Configuration",
    "notesLabel": "Notes",
    "modelTooltip": "Display aircraft model on aircraft",
    "modelLabel": "Model",
    "footprintTooltip": "Show wingspan and length on selected aircraft",
    "footprintLabel": "Footprint",
    "sopSpacingTooltip": "Horizontal spacing outline",
    "sopSpacingLabel": "SOP Spacing",
    "wallSpacingTooltip": "Wall spacing visual fill areas",
    "wallSpacingLabel": "Wall Spacing Fill",
    "bayBoundariesTooltip": "Show bay boundaries for stepped-eave hangars",
    "bayBoundariesLabel": "Bay Boundaries",
    "overlapsTooltip": "Highlights all overlaps, doesn't evaluate vertical spacing safety",
    "overlapsLabel": "Overlaps",
    "coPilotTooltip": "Select unstacked aircraft and get SOP-compliant options",
    "coPilotLabel": "Co-Pilot",
    "tugLabel": "Tug",
    "useFBODefault": "Use FBO Default ({{defaultTugName}})",
    "spotsTooltip": "Display parking spots on ramp",
    "spotsLabel": "Spots",
    "rampImageTooltip": "Overlay ramp satellite image",
    "rampImageLabel": "Ramp Image",
    "zoneHeatmapTooltip": "Show zone occupancy heatmap (next {{hours}}h)",
    "zoneHeatmapLabel": "Zone Heatmap",
    "hours24": "24h",
    "hours72": "72h",
    "week1": "1w",
    "none": "None"
  },
  "currentAircraft": {
    "title": "Current Aircraft"
  },
  "layout": {
    "permissionDenied": {
      "modifyLayout": "You don't have permission to modify the layout"
    },
    "deleteConfirmation": {
      "confirmAircraft": "Confirm Aircraft",
      "confirmObstacle": "Confirm Obstacle",
      "removeAircraft": "Remove Aircraft",
      "removeObstacle": "Remove Obstacle",
      "removeTransient": "Remove Transient",
      "title": "Delete Confirmation"
    }
  }
}
